// Components==============
import { faCheck, faCopy } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { motion } from 'framer-motion';
import Tooltip from 'components/UI/Tooltip/Tooltip';
import './ShareCodeButton.module.scss';
// =========================
type Status = 'inactive' | 'copied';

const variantsLeft = {
  inactive: {
    color: '#0827e9',
  },
  copied: {
    color: '#2addd0',
  },
};

const variantsRight = {
  inactive: {
    background: '#0827e9',
  },
  copied: {
    background: '#2addd0',
  },
};

export default function ShareCodeButton({
  sharecode,
  type,
}: {
  sharecode?: string;
  type: 'projects' | 'courses';
}) {
  const translate = useTranslate();
  const [status, setStatus] = useState<Status>('inactive');

  if (!sharecode) return <></>;

  function copiedClick() {
    navigator.clipboard.writeText(sharecode!);
    setStatus('copied');
    setTimeout(function () {
      setStatus('inactive');
    }, 2000);
  }

  return (
    <div
      styleName="sharecode-button"
      onClick={() => {
        copiedClick();
      }}
    >
      <Tooltip
        fullWidth
        position="bottom"
        content={<p>{translate(`general.sharecode.tooltip-${type}`)}</p>}
      >
        <motion.div
          variants={variantsLeft}
          animate={status}
          initial="inactive"
          styleName="left"
        >
          <p>{sharecode}</p>
        </motion.div>
      </Tooltip>
      <motion.div
        whileHover={status !== 'copied' ? { background: '#2c48f8' } : undefined}
        variants={variantsRight}
        animate={status}
        initial="inactive"
        styleName="right"
      >
        <FontAwesomeIcon icon={status === 'inactive' ? faCopy : faCheck} />
      </motion.div>
    </div>
  );
}
